
















import { IOci } from '@/contract/oci.contract';
import masterdataStore from '@/store/modules/masterdata/masterdataStore';
import { Component, Vue } from 'vue-property-decorator';
import Oci from './OCIInfo.vue';

@Component({
  components: {
    Oci,
  },
})
export default class Partners extends Vue {
  public created(): void {
    masterdataStore.dispatch.fetchOcis();
  }

  public get ocis(): IOci[] {
    return masterdataStore.getters.ocis().filter(oci => oci.active);
  }
}
